export interface Product {
  id: string;
  name: string;
  nameEn: string;
  description: string;
  descriptionEn: string;
  price: number;
  originalPrice?: number;
  image: string;
  category: string;
  rating: number;
  reviewCount: number;
  stock: number;
  badges?: string[];
  features?: string[];
  recommend?: string[]; // "ranking" | "new" | "sale" | "rare"
}

export const CATEGORIES = [
  "all",
  "literature",
  "art_design",
  "humanities",
  "social_science",
  "philosophy",
  "business",
  "language",
  "health",
  "travel",
  "food_craft",
  "science",
  "computer",
  "children",
  "exam",
  "acg",
] as const;

export type Category = (typeof CATEGORIES)[number];

export const RECOMMEND_TABS = ["all", "ranking", "new", "sale", "rare"] as const;
export type RecommendTab = (typeof RECOMMEND_TABS)[number];

export const MOCK_PRODUCTS: Product[] = [
  {
    id: "p1",
    name: "百年孤寂（全新典藏版）",
    nameEn: "One Hundred Years of Solitude (Collector's Edition)",
    description: "諾貝爾文學獎得主馬乎斯經典鉅作，全新中文翻譯典藏版。收錄獨家導讀與作者年表，精裝燙金設計。",
    descriptionEn: "Nobel Prize winner García Márquez's masterpiece. New Chinese translation collector's edition with exclusive foreword and author timeline.",
    price: 520,
    originalPrice: 650,
    image: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=400&fit=crop",
    category: "literature",
    rating: 4.9,
    reviewCount: 2341,
    stock: 180,
    badges: ["熱銷"],
    features: ["精裝版", "全新翻譯", "典藏設計"],
    recommend: ["ranking", "sale"],
  },
  {
    id: "p2",
    name: "設計的法則：100個影響認知的設計原理",
    nameEn: "Universal Principles of Design",
    description: "涵蓋100個跨領域設計原則，以圖文並茂的方式解說。從心理學到工業設計，是設計師與創作者必備工具書。",
    descriptionEn: "Covers 100 cross-disciplinary design principles with rich illustrations. Essential reference for designers and creators.",
    price: 680,
    image: "https://images.unsplash.com/photo-1541963463532-d68292c34b19?w=400&h=400&fit=crop",
    category: "art_design",
    rating: 4.6,
    reviewCount: 876,
    stock: 95,
    features: ["全彩印刷", "100個原則", "跨領域"],
    recommend: ["ranking"],
  },
  {
    id: "p3",
    name: "人類大歷史：從野獸到扮演上帝",
    nameEn: "Sapiens: A Brief History of Humankind",
    description: "全球暢銷超過2000萬冊。哈拉瑞以宏觀視角重新審視人類文明的發展軌跡，從認知革命到人工智慧時代。",
    descriptionEn: "Over 20 million copies sold worldwide. Yuval Noah Harari examines human civilization from the Cognitive Revolution to AI.",
    price: 450,
    originalPrice: 600,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
    category: "humanities",
    rating: 4.8,
    reviewCount: 5672,
    stock: 230,
    badges: ["熱銷"],
    features: ["全球暢銷", "宏觀視角"],
    recommend: ["ranking", "sale"],
  },
  {
    id: "p4",
    name: "正義：一場思辨之旅",
    nameEn: "Justice: What's the Right Thing to Do?",
    description: "哈佛最受歡迎的公開課程講師桑德爾教授的經典之作。探討自由、公平與道德的根本問題。",
    descriptionEn: "Harvard's most popular professor Michael Sandel explores fundamental questions about freedom, fairness, and morality.",
    price: 380,
    image: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?w=400&h=400&fit=crop",
    category: "social_science",
    rating: 4.7,
    reviewCount: 3214,
    stock: 120,
    features: ["哈佛課程", "哲學思辨"],
    recommend: ["ranking"],
  },
  {
    id: "p5",
    name: "被討厭的勇氣",
    nameEn: "The Courage to Be Disliked",
    description: "以阿德勒心理學為基礎，透過對話形式探討「如何獲得幸福」。日本銷售突破300萬冊的現象級著作。",
    descriptionEn: "Based on Adlerian psychology, explores 'how to find happiness' through dialogue format. A phenomenal bestseller in Japan.",
    price: 330,
    originalPrice: 400,
    image: "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=400&h=400&fit=crop",
    category: "philosophy",
    rating: 4.5,
    reviewCount: 8921,
    stock: 340,
    badges: ["熱銷"],
    features: ["阿德勒心理學", "對話形式"],
    recommend: ["ranking", "sale"],
  },
  {
    id: "p6",
    name: "原子習慣：細微改變帶來巨大成就的實證法則",
    nameEn: "Atomic Habits",
    description: "每天進步1%，一年後將進步37倍。詹姆斯‧乎利爾以科學實證，教你打造好習慣、戒除壞習慣的系統方法。",
    descriptionEn: "James Clear's proven framework for building good habits and breaking bad ones. Tiny changes, remarkable results.",
    price: 330,
    image: "https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=400&h=400&fit=crop",
    category: "business",
    rating: 4.8,
    reviewCount: 12453,
    stock: 500,
    badges: ["熱銷"],
    features: ["實證法則", "系統方法", "習慣養成"],
    recommend: ["ranking"],
  },
  {
    id: "p7",
    name: "新日檢 N2 完全攻略",
    nameEn: "JLPT N2 Complete Guide",
    description: "涵蓋文字語彙、文法、讀解、聽解四大領域。附贈模擬試題與音檔下載，備考最佳良伴。",
    descriptionEn: "Covers vocabulary, grammar, reading, and listening. Includes mock tests and audio downloads for comprehensive prep.",
    price: 420,
    image: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?w=400&h=400&fit=crop",
    category: "language",
    rating: 4.4,
    reviewCount: 1567,
    stock: 200,
    features: ["四大領域", "模擬試題", "音檔下載"],
    recommend: ["new"],
  },
  {
    id: "p8",
    name: "逆齡飲食：抗老化的營養科學",
    nameEn: "Anti-Aging Nutrition Science",
    description: "結合最新營養學研究，提供實用的抗老化飲食方案。從細胞層級解析食物如何影響老化進程。",
    descriptionEn: "Combines latest nutritional research with practical anti-aging dietary plans. Cellular-level analysis of how food affects aging.",
    price: 380,
    image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=400&h=400&fit=crop",
    category: "health",
    rating: 4.3,
    reviewCount: 423,
    stock: 85,
    features: ["營養科學", "實用方案"],
    recommend: ["new"],
  },
  {
    id: "p9",
    name: "日本深度旅行：在地人帶路的私房景點",
    nameEn: "Japan Deep Travel: Local's Secret Spots",
    description: "收錄50個非觀光客路線的隱藏版景點。由在日生活10年的作者親自走訪，附詳細交通指南與地圖。",
    descriptionEn: "50 hidden gems off the tourist trail. Written by a 10-year Japan resident with detailed transit guides and maps.",
    price: 480,
    image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=400&h=400&fit=crop",
    category: "travel",
    rating: 4.6,
    reviewCount: 2108,
    stock: 150,
    badges: ["新品"],
    features: ["50個景點", "交通指南", "在地視角"],
    recommend: ["new", "ranking"],
  },
  {
    id: "p10",
    name: "職人手作：從零開始學皮革工藝",
    nameEn: "Leather Craft: From Zero to Artisan",
    description: "完整的皮革工藝入門指南，從工具選購到進階技法。附贈12個實作專案的紙型與步驟圖解。",
    descriptionEn: "Complete leather crafting beginner's guide from tool selection to advanced techniques. Includes 12 project patterns.",
    price: 560,
    image: "https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=400&h=400&fit=crop",
    category: "food_craft",
    rating: 4.5,
    reviewCount: 634,
    stock: 70,
    features: ["12個專案", "紙型附贈", "步驟圖解"],
    recommend: ["new"],
  },
  {
    id: "p11",
    name: "量子力學的奇幻旅程",
    nameEn: "The Fantastic Journey of Quantum Mechanics",
    description: "用故事性筆觸帶領讀者進入量子世界。深入淺出解說波粒二象性、量子糾纏、薛丁格的貓等核心概念。",
    descriptionEn: "A narrative journey into the quantum world. Accessible explanations of wave-particle duality, quantum entanglement, and more.",
    price: 420,
    originalPrice: 520,
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&h=400&fit=crop",
    category: "science",
    rating: 4.4,
    reviewCount: 892,
    stock: 110,
    features: ["科普讀物", "深入淺出"],
    recommend: ["sale"],
  },
  {
    id: "p12",
    name: "Python 資料科學實戰",
    nameEn: "Python Data Science in Practice",
    description: "從 Python 基礎到機器學習應用的完整學習路徑。包含 Pandas、NumPy、Scikit-learn 實戰範例與練習題。",
    descriptionEn: "Complete learning path from Python basics to ML applications. Hands-on examples with Pandas, NumPy, and Scikit-learn.",
    price: 620,
    image: "https://images.unsplash.com/photo-1515879218367-8466d910auj7?w=400&h=400&fit=crop",
    category: "computer",
    rating: 4.7,
    reviewCount: 3456,
    stock: 280,
    badges: ["熱銷"],
    features: ["Python", "機器學習", "實戰範例"],
    recommend: ["ranking", "new"],
  },
  {
    id: "p13",
    name: "小王子（法中對照精裝典藏版）",
    nameEn: "The Little Prince (French-Chinese Collector's Edition)",
    description: "聖修伯里不朽經典，法中雙語精裝版。收錄原版水彩插畫，附加注音適合親子共讀。",
    descriptionEn: "Saint-Exupéry's timeless classic in French-Chinese bilingual hardcover. Original watercolor illustrations with phonetic aids.",
    price: 480,
    originalPrice: 600,
    image: "https://images.unsplash.com/photo-1589998059171-988d887df646?w=400&h=400&fit=crop",
    category: "children",
    rating: 4.9,
    reviewCount: 4521,
    stock: 190,
    badges: ["珍藏"],
    features: ["法中對照", "精裝版", "原版插畫"],
    recommend: ["rare", "sale"],
  },
  {
    id: "p14",
    name: "國考行政法概要精華",
    nameEn: "Civil Service Exam: Administrative Law Essentials",
    description: "針對國家考試行政法科目，彙整重要條文、判例與歷屆考題解析。圖表化整理幫助快速理解與記憶。",
    descriptionEn: "Comprehensive administrative law review for civil service exams. Organized charts, cases, and past exam analysis.",
    price: 550,
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400&h=400&fit=crop",
    category: "exam",
    rating: 4.3,
    reviewCount: 987,
    stock: 160,
    features: ["歷屆考題", "圖表整理", "條文彙整"],
    recommend: ["new"],
  },
  {
    id: "p15",
    name: "進擊的巨人（全套典藏版）",
    nameEn: "Attack on Titan (Complete Collector's Set)",
    description: "諫山創史詩鉅作完整收藏。全34卷精裝盒裝版，附贈限定海報與角色設定集。",
    descriptionEn: "Hajime Isayama's epic masterpiece complete collection. All 34 volumes in premium box set with exclusive poster and artbook.",
    price: 4800,
    originalPrice: 6200,
    image: "https://images.unsplash.com/photo-1608889175123-8ee362201f81?w=400&h=400&fit=crop",
    category: "acg",
    rating: 4.9,
    reviewCount: 6789,
    stock: 25,
    badges: ["珍藏", "限量"],
    features: ["全34卷", "精裝盒裝", "限定海報"],
    recommend: ["rare", "ranking"],
  },
  {
    id: "p16",
    name: "窮查理的普通常識",
    nameEn: "Poor Charlie's Almanack",
    description: "查理·蒙格的智慧箴言與投資哲學。涵蓋跨領域思維模型，是投資人與企業家必讀的思考指南。",
    descriptionEn: "Charlie Munger's wisdom and investment philosophy. Cross-disciplinary mental models for investors and entrepreneurs.",
    price: 480,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=400&fit=crop",
    category: "business",
    rating: 4.7,
    reviewCount: 4231,
    stock: 175,
    features: ["投資哲學", "思維模型"],
    recommend: ["ranking"],
  },
  {
    id: "p17",
    name: "世界宗教入門：從佛教到伊斯蘭",
    nameEn: "Introduction to World Religions",
    description: "全面介紹全球主要宗教的歷史、教義與文化影響。客觀中立的學術立場，適合通識學習。",
    descriptionEn: "Comprehensive introduction to major world religions covering history, doctrine, and cultural influence.",
    price: 390,
    image: "https://images.unsplash.com/photo-1507692049790-de58290a4334?w=400&h=400&fit=crop",
    category: "philosophy",
    rating: 4.2,
    reviewCount: 543,
    stock: 90,
    features: ["學術中立", "全面介紹"],
    recommend: ["new"],
  },
  {
    id: "p18",
    name: "居家烘焙的幸福時光",
    nameEn: "Happy Home Baking",
    description: "50道經典與創意烘焙食譜。從基礎麵團到法式甜點，步驟詳盡配有全彩照片，新手也能輕鬆上手。",
    descriptionEn: "50 classic and creative baking recipes. From basic doughs to French pastries with detailed steps and full-color photos.",
    price: 450,
    originalPrice: 560,
    image: "https://images.unsplash.com/photo-1486427944544-d2c246c4d3b3?w=400&h=400&fit=crop",
    category: "food_craft",
    rating: 4.6,
    reviewCount: 1876,
    stock: 135,
    badges: ["熱銷"],
    features: ["50道食譜", "全彩照片", "新手友善"],
    recommend: ["ranking", "sale"],
  },
];
